(() => {
  const dialog = document.getElementById('ProductNotifyModal');
  if (!(dialog instanceof HTMLDialogElement)) return;
  let opener;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-product-notify]');
    if (!(link instanceof HTMLAnchorElement) || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    opener = link;
    const section = link.closest('[data-product-section]');
    const variantId = section?.querySelector('[name="id"]')?.value;
    const productUrl = new URL(link.dataset.productUrl);
    if (variantId) productUrl.searchParams.set('variant', variantId);
    const title = link.dataset.productTitle;
    dialog.querySelector('[data-notify-product]').textContent = title;
    const whatsappUrl = new URL(link.href);
    whatsappUrl.searchParams.set('text', dialog.dataset.message.replace('__PRODUCT__', () => title).replace('__URL__', () => productUrl.href));
    dialog.querySelector('[data-notify-whatsapp]').href = whatsappUrl.href;
    if (!dialog.open) dialog.showModal();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opener?.isConnected) opener.focus();
    opener = undefined;
  });
})();
